import { CreditsPill } from './CreditsPill';
import { Logo } from './Logo';
import { ThemeToggle } from './ThemeToggle';

/** Header of the five main screens: the mark, the theme switch and the balance. */
export function AppHeader() {
  return (
    <header className="safe-top">
      <div className="flex items-center justify-between gap-3 px-4 pt-3 pb-2 max-w-lg mx-auto">
        <Logo />
        <div className="flex items-center gap-2 flex-shrink-0">
          <ThemeToggle />
          <CreditsPill />
        </div>
      </div>
    </header>
  );
}
